export default __webpack_public_path__ + "static/media/lotto.478a6817.jpg";